@if (group.criteriaGroup) {
  <div>
    <button class="transparent" hisImage="tag_group_add" (click)="addCriteriaGroup($event)">
      <span>{{'genericSearch.addCriteriaGroup' | hisUi}}</span>
    </button>
    <button (click)="criteriaGroupHelp.toggle($event)"
    hisImage="information" class="icon"
    [title]="('cs.sys.fieldset.help' | hisUi) + ' ' + ('genericSearch.addCriteriaGroup' | hisUi)"></button>
    <p-overlayPanel #criteriaGroupHelp [showCloseIcon]="true" [dismissable]="true">
        <div [innerHTML]="'genericSearch.criteriaGroup.helptext' | hisUi"></div>
    </p-overlayPanel>
    @if (currentCriteriagroup) {
      <p-dialog
        [(visible)]="criteriagroupOverlayVisible"
        [draggable]="false"
        [closeOnEscape]="true"
        [resizable]="false"
        [responsive]="true"
        [modal]="true"
        [blockScroll]="true"
        styleClass="minWidth75"
        (onHide)="cancelEditCriteriaGroup($event)"
        [header]="'genericSearch.addCriteriaGroup' | hisUi">
        <div>
          <his-helptext
            [subtitle]="'genericSearch.addCriteriaGroup' | hisUi"
            [helptext]="'genericSearch.criteriaGroup.helptext' | hisUi">
          </his-helptext>
   		</div>
        <!-- Einschlißende bzw. Ausschließende Kriteriengruppe -->
        <div>
          <his-plam
          styleClass="noLabelContentLine_50"
          id="includeOptionPlam"
          label=" ">
            <fieldset class="fieldsetGroup" #content>
              <div class="optionsInline">
                <input type="radio" 
                  id="includeOption" 
                  name="includeExcludeCriteriaGroup" 
                  [(ngModel)]="currentCriteriagroup.notInCriteriaGroup"
                  [value]="false" 
                  class="plamOptionVertical">
                <label for="includeOption">{{'genericSearch.criteriaGroup.include' | hisUi}}</label>
                
                <input type="radio" 
                  id="includeOption2" 
                  name="includeExcludeCriteriaGroup" 
                  [(ngModel)]="currentCriteriagroup.notInCriteriaGroup"
                  [value]="true" 
                  class="plamOptionVertical">
                <label for="includeOption2">{{'genericSearch.criteriaGroup.exclude' | hisUi}}</label>
              </div>
            </fieldset>
          </his-plam>
        </div>
        @for (widget of currentCriteriagroup.widgets; track widget) {
          <div>
            <div>
              <his-search-form-widget
                [widget]="widget"
                [form]="form"
                [showErrors]="true">
              </his-search-form-widget>
            </div>
          </div>
        }
        <!-- 	    <ng-template #footer> -- siehe Hiszilla #300792> -->
        <button (click)="saveCriteriaGroup($event)">{{'common.save' | hisUi}}</button>
        <button (click)="cancelEditCriteriaGroup($event)">{{'common.cancel' | hisUi}}</button>
      <!-- 	    </ng-template> -->
    </p-dialog>
  }
  <!-- Verunden oder verodern von mehr als einer Kriteriengruppe -->
  @if (group.criteriaGroups.length > 1) {
    <div>
      <input type="radio"
        [id]="group.id + 'combineCriteriaGroupsByOr_and'"
        [(ngModel)]="group.combineCriteriaGroupsByOr"
        [value]="false"
        [name]="group.id + 'combineCriteriaGroupsByOr'" />
      <label [for]="group.id + 'combineCriteriaGroupsByOr_and'">
        {{'genericSearch.criteriaGroup.and.label' | hisUi}}
      </label>
      <input type="radio"
        [id]="group.id + 'combineCriteriaGroupsByOr_or'"
        [(ngModel)]="group.combineCriteriaGroupsByOr"
        [value]="true"
        [name]="group.id + 'combineCriteriaGroupsByOr'" />
      <label [for]="group.id + 'combineCriteriaGroupsByOr_or'">
        {{'genericSearch.criteriaGroup.or.label' | hisUi}}
      </label>
    </div>
  }
  <!-- Anzeige, wenn es bereits hinzugefügt wurde -->
  @if (group.criteriaGroups.length > 0 && !isAddMode && !isEditMode) {
    <div>
      <ul class="listStyleIconSimple">
        @for (criteriaGroup of group.criteriaGroups; track criteriaGroup) {
          <li>
            @if (!criteriaGroup.notInCriteriaGroup) {
              <strong>{{'genericSearch.criteriaGroup.include' | hisUi}}: </strong>
            }
            @if (criteriaGroup.notInCriteriaGroup) {
              <strong>{{'genericSearch.criteriaGroup.exclude' | hisUi}}: </strong>
            }
            @for (widget of criteriaGroup.widgets; track widget) {
              <span>
                @if (isValueToShow(widget.value)) {
                  <span>{{widget.label | hisUi}}: {{widgetValueAsString(widget)}} </span>
                }
              </span>
            }
            <button class="transparent" hisImage="delete" (click)="removeCriteriaGroup($event, criteriaGroup)" [title]="'genericSearch.removeCriteriaGroup' | hisUi"></button>
            <button class="transparent" hisImage="pencil" (click)="editCriteriaGroup($event, criteriaGroup)" [title]="'genericSearch.editCriteriaGroup' | hisUi"></button>
          </li>
        }
      </ul>
    </div>
  } 
</div>
}